export const apiRefresh = (map) => {
  if (map) {
    map.map.invalidateSize()
  }
}
